import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6 2L17.04 3.5L8.82814 12L17.04 20.5L15.6 22L5.99998 12L15.6 2Z"
    />
  </React.Fragment>,
  `BackArrowIcon`
);
